var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stream-controls"},[(_vm.activeTab === 'constructor')?[_c('select-locale'),_c('select-template'),_c('select-page'),_c('select-size')]:_vm._e(),_c('actions')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }